import { render } from "./SubmitForm.vue?vue&type=template&id=bf42ad64"
import script from "./SubmitForm.vue?vue&type=script&lang=js"
export * from "./SubmitForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/vokaladezful-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__